import { BodyVariant, SizeOptions } from '../../../../types/types'

export const sizeStyles: Record<SizeOptions, string> = {
    small: '!min-h-5', // 20px
    medium: '!min-h-7', // 28px
    large: '!min-h-9', // 36px
}

export const typographyStyles: Record<SizeOptions, BodyVariant> = {
    small: 'body-small',
    medium: 'body',
    large: 'body',
}
